import { useQuery } from "@tanstack/react-query";
import { knockClient } from "../utils/knockClient";
import { useKnockAuth } from "./useKnockAuth";

export const preferencesQueryKey = { queryKey: ["knock-preferences"] };

async function fetchKnockPreferences() {
    try {
        return await knockClient.user.getPreferences();
    } catch (error) {
        const status =
            (error as { response?: { status?: number }; status?: number })?.response?.status ??
            (error as { status?: number })?.status;
        if (status === 401 || status === 403) {
            return null;
        }
        throw error;
    }
}

export function usePreferencesQuery() {
    const { isSuccess: isAuthenticated } = useKnockAuth();

    return useQuery({
        ...preferencesQueryKey,
        queryFn: fetchKnockPreferences,
        enabled: isAuthenticated,
        retry: false,
    });
}

function preferencesLeaveNotificationsOff(
    preferences: { channel_types?: { email?: unknown; sms?: unknown } } | null | undefined
) {
    if (preferences == null || Object.keys(preferences).length === 0) return true;
    return !preferences.channel_types?.email && !preferences.channel_types?.sms;
}

/**
 * True once we know reminders are not set up: preferences missing, failed to load,
 * or both email and SMS turned off. Stays false while the request is still in flight.
 */
export function useAreAllNotificationsDisabled() {
    const knockAuth = useKnockAuth();
    const preferences = usePreferencesQuery();

    if (!knockAuth.isFetched) return false;
    if (knockAuth.isError) return true;
    if (!preferences.isFetched) return false;
    if (preferences.isError) return true;
    return preferencesLeaveNotificationsOff(preferences.data);
}
